const alertSuccess = {
    props: ["msgs", "dismissible"],
    template: `
      <div class="alert alert-success alert--icon fade show"
        v-bind:class="[ dismissible ? 'alert-dismissible' : '' ]"
        role="alert">
          <ul class="ulClear">
              <li v-for="(msg,index) in msgs"
                  :key="index">
                  <span>{{ msg }}</span>
              </li>
          </ul>
          <button v-if="dismissible" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`
}

commonComponents.push({
    name: 'alert-success',
    var: alertSuccess
})